import { FC, PropsWithChildren } from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { environment } from 'config/environment';

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      retry: false,
    },
    queries: {
      cacheTime: 5 * 60 * 1000,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 10 * 60 * 1000,
    },
  },
});

export const ReactQueryProvider: FC<
  PropsWithChildren<Record<never, never>>
> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {!environment.IS_PRODUCTION && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
    </QueryClientProvider>
  );
};
